import type {
  KeyboardEventHandler,
  MouseEventHandler,
  MutableRefObject,
} from 'react'
import { Keys } from '../utilities/keyboard'

interface ForwardClickActions<ElementType> {
  handleClick: MouseEventHandler<ElementType>
  handleKeyDown: KeyboardEventHandler<ElementType>
}

export function useForwardClick<ElementType extends HTMLElement>(
  ref: MutableRefObject<ElementType | null>,
  selector: string,
): ForwardClickActions<ElementType> {
  const handleClick: MouseEventHandler<ElementType> = (event) => {
    if (event.target === ref.current) {
      event.preventDefault()

      ref.current.querySelector<HTMLInputElement>(selector)?.click()
    }
  }

  const handleKeyDown: KeyboardEventHandler<ElementType> = (event) => {
    if ((event.key === Keys.Enter || event.key === Keys.Space) && ref.current) {
      event.preventDefault()

      ref.current.querySelector<HTMLInputElement>(selector)?.click()
    }
  }

  return { handleClick, handleKeyDown }
}
